import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { ProcesoService } from '../../../services/proceso.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ModalService } from 'src/app/services/modal.service';
import { AlertService } from './../../../../../services/alert.service';
import { IndicadoresService } from '../../../services/indicadores.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ObjetivoService } from '../../../services/objetivo.service';
import { PlanesInstitucionalesAnualesService } from 'src/app/modulos/catalogos-admin/services/planes-institucionales-anuales.service';


@Component({
  selector: 'app-indicadores-procesos',
  templateUrl: './indicadores-procesos.component.html',
  styleUrls: ['./indicadores-procesos.component.css']
})
export class IndicadoresProcesosComponent {
  public formProcesosIndicadores: UntypedFormGroup;
  public submitted = false;
  public dataProcesosIndicadores: any = [];
  public dataProcesos: any = [];
  public dataIndicadores: any[] = [];
  public dataObjetivo: any[] = [];
  private idDeleteRegister: number = 0;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public nameModal: string = 'procesos-modalNewEdit'
  public nameApp = 'INDICADOR-PROCESO';
  public selectItems: any = [];
  public idSprAmbiente: number = 0;
  private idSprPlanAnio: number = 0;
  public nameModalConfig: string = 'ModalConfiguracionProceso'
  public nameModalCumple: string = 'modalCumple'
  public dataResponsableProceso: any = [];
  public desripcionProceso: any = [];
  public dataElementosParticpantes: any = [];
  public dataEquipoGerencial!: any;
  public dataTipoParticpacion: any = [];
  public dataIndicador1: any[0] = [0];
  public descripcionIndicador !: any;
  public descripcionConfigIndicador !: any;
  public cumpleIndicadores = [];
  public nombreProceso = [];
  tipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  public idResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;
  public estadoActivo: number = 1;
  public idSprNivel: number = 0;

  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;

  //Array que almacena los ids de los objetivos del plan anual seleccionado
  public dataObjetivosPorAnio: any = null;
  


  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @Input() set init(objetivo: any) {
    this.initApp(objetivo);
  }
  @Input() set idsObjetivos(dataObjetivosPorAnio: any) {
    this.dataObjetivosPorAnio = dataObjetivosPorAnio;
  }

  @Input() set planAnual(planAnioSeleccionadoRedux: any) {
    this.planAnioSeleccionadoRedux = planAnioSeleccionadoRedux;
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    public modal: ModalService,
    private indicadorService: IndicadoresService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private comunService: ComunService,
    private procesosService: ProcesoService,
    private objetivosService: ObjetivoService,
    private participanteElementoService: ParticipanteElementoService,
    private equipoGerencialService: EquipoGerencialService,
    public store: Store<AppState>,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    //this.idSprAmbiente = this.currentUser.idSprAmbiente;
  }

  initApp(data: string = 'proceso') {
    if (data == 'proceso') {
      this.store.select('globalApp').subscribe(response => {
        this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
        this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
        this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
        this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
        this.initProcesosIndicadores();
      })
    }
  }

  initProcesosIndicadores() {
    forkJoin([
      this.objetivosService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprPlanAnio=${this.idSprPlanAnio}&estado=${this.estadoActivo}`),
      this.procesosService.list(`?idSprAmbiente=${this.idSprAmbiente}&estado=${this.estadoActivo}`),
      this.indicadorService.list(),
      this.equipoGerencialService.list('?idSprAmbiente=' + this.idSprAmbiente),
      this.comunService.list('?spr_idSprComun' + this.tipoParticipante),
      this.participanteElementoService.list('?estado=1'),
    ]).pipe(map(
      ([objetivos, procesos, indicadores, dataEquipoGerencial, respTipoParticipa, participantes]) => {
        this.dataObjetivo = objetivos;
        this.dataProcesos = procesos;
        this.dataIndicadores = indicadores;
        this.dataEquipoGerencial = dataEquipoGerencial;
        this.dataTipoParticpacion = respTipoParticipa;
        this.dataElementosParticpantes = participantes;
        this.mapeoEquipoGerencialTipoParticipa();
        this.mapingDataProcesosIndicadores();
      })).subscribe();
  }

  mapingDataProcesosIndicadores() {
    this.dataProcesosIndicadores = []
    let indiceUno = 0; let dataProcess: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataProcesos.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataProcesos[j].idSprObjetivo) {
          for (let k = 0; k < this.dataIndicadores.length; k++) {
            if (this.dataIndicadores[k].idSprProceso == this.dataProcesos[j].idSprProceso) {

              dataProcess.push({
                idSprIndicador: this.dataIndicadores[k].idSprIndicador,
                nombre: this.dataIndicadores[k].nombre,
                descripcion: this.dataIndicadores[k].descripcion,
                fechaInicio: this.dataIndicadores[k].fechaInicio,
                unidadInformacion: this.dataIndicadores[k].unidadInformacion,
                estado: this.dataIndicadores[k].estado,
                idSprProceso: this.dataIndicadores[k].idSprProceso,
                idSprResponsable: this.dataIndicadores[k].idSprResponsable
              }); indiceUno++;
            }
          }
          this.dataProcesosIndicadores.push({
            nombreProceso: this.dataProcesos[j].nombre,
            idSprProceso: this.dataProcesos[j].idSprProceso,
            indicadores: dataProcess
          }); dataProcess = [];
        }
      }
    }
  }

  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
      for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
        if (this.dataEquipoGerencial[i].idSprTipoParticipante === this.dataTipoParticpacion[j].idSprComun && this.dataEquipoGerencial[i].estado == 1 && this.dataEquipoGerencial[i].idSprTipoParticipante == this.idResponsable) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }




  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  get appForm() {
    return this.formProcesosIndicadores.controls;
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe(response => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin
      this.getIpPublic();
      this.setFormProcesos();
    })
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }


  setFormProcesos(idSprProceso: string = " ") {
    this.formProcesosIndicadores = this.fb.group({
      idSprProceso: [idSprProceso],
      idSprIndicador: [],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [''],
      unidadInformacion: [''],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      estado: ['', [Validators.required]],
    });
  }

  delete(row: any) {
    this.idDeleteRegister = row.idSprIndicador;
    this.modal.open('delete-proceso');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.indicadorService.update({
        "idSprIndicador": this.idDeleteRegister,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.initApp();
        this.alert.deleteOk();
        this.modal.close();
      }, (err) => {
        this.alert.deleteError();
        this.modal.close();
      });
    }
  }

  configuracionInit(obj: any) {

    this.descripcionIndicador = obj.nombre;
    this.dataIndicador1 = obj;
    this.openModal1();
  }

  cumpleInit(obj: any) {
    this.descripcionConfigIndicador = obj.nombre;
    this.dataIndicador1 = obj;
    this.openModal2();
  }

  edit(obj: any, row: any) {
    this.onResetForm();
    this.nombreProceso = row.nombreProceso;
    this.setFormProcesos(obj.idSprProceso)
    this.formProcesosIndicadores.patchValue({
      idSprIndicador: obj.idSprIndicador,
      idSprProceso: obj.idSprProceso,
      idSprEquipoGerencial: obj.idSprResponsable,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      unidadInformacion: obj.unidadInformacion,
      fechaInicio: obj.fechaInicio,
      estado: obj.estado,
    });
    this.modal.open(this.nameModal);
  }

  onSubmit() {
    this.submitted = true;
    this.formProcesosIndicadores.value.usuario = this.currentUser.idSprUsuario;
    this.formProcesosIndicadores.value.ip = this.ipAddress;
    this.formProcesosIndicadores.value.idSprResponsable = this.formProcesosIndicadores.value.idSprEquipoGerencial;

    if (!this.formProcesosIndicadores.invalid) {
      if (this.formProcesosIndicadores.value.idSprIndicador == null) {
        this.indicadorService.create(this.formProcesosIndicadores.value).subscribe(
          (resp) => {
            ///this.initApp();
            this.initProcesosIndicadores();
            this.closeModalConfiguracion();
            this.alert.createOk();
            this.initApp();
          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.indicadorService.update(this.formProcesosIndicadores.value).subscribe(
          (resp) => {
            this.initProcesosIndicadores();
            this.closeModalConfiguracion();
            this.alert.updateOk();
            this.initApp();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
      return;
    }
  }

  ConfguracionPlanAccionInit(obj: any) {
    this.desripcionProceso = obj.nombreProceso;
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onResetForm() {
    this.submitted = false;
    this.formProcesosIndicadores.reset();
  }

  openModal(row: any) {
    this.onResetForm();
    this.setFormProcesos(row.idSprProceso);
    this.nombreProceso = row.nombreProceso;
    this.modal.open(this.nameModal);
  }

  openModal1() {
    this.onResetForm();
    this.modal.open(this.nameModalConfig);
  }
  openModal2() {
    this.onResetForm();
    this.modal.open(this.nameModalCumple);
  }

  closeModalConfiguracion() {
    this.modal.closeId(this.nameModal);
    this.reDrawDataTable()
  }
}
